// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"ecd683ce","967":"a8262ff2"}[chunkId] + ".chunk.js";
};